import 'devextreme/dist/css/dx.common.css';
import "devextreme/dist/css/dx.light.css";
import Vue from 'vue';
import App from './App.vue';
import { AppConstants } from './core/Export';
import i18n from './i18n';
import './quasar';
import router from './router';
import store from './store';
import { versionCheck } from './versionCheck';

Vue.config.productionTip = false;

function mountApp(): void {
  new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
  }).$mount('#app');
}

if (window["cordova"]) {
  console.log("cordova", window["cordova"]);
  mountApp();
} else {
  versionCheck(AppConstants.Http.BaseUrl)
    .then(shouldMount => {
      if (shouldMount) mountApp();
    });
}
